export function HeaderDivider() {
  return <div className="h-4 w-px bg-border-primary mx-1" />;
}
